module.exports = __webpack_public_path__ + "static/media/picasso-15.6ca96b40.jpeg";